import { createApi } from "@reduxjs/toolkit/query/react";
import { createCustomFetchBaseQuery } from "../baseQuery";

export const geographicAdjusterApi = createApi({
  reducerPath: "admin-geographic-adjuster",
  tagTypes: ["GeographicAdjuster"],
  baseQuery: createCustomFetchBaseQuery(),
  endpoints: (builder) => ({

    // ✅ Get all geographic adjusters
    getAllGeographicAdjusters: builder.query({
      query: ({ pageno, search ,sortOrder , sortBy, limit }) => {
        let url = `admin/geographic-adjusters?pageno=${pageno}`;

        if (search) {
          url += `&search=${encodeURIComponent(search)}`;
        }
        if(sortBy){
          url += `&sortBy=${sortBy}`;
        }
        if(sortOrder){
          url += `&sortOrder=${sortOrder}`;
        }
        if(limit){
          url += `&limit=${limit}`;
        }
        return {
          url,
          method: "GET",
        };
      },
      transformResponse: (res) => res,
      providesTags: ["GeographicAdjuster"],
    }),

    // ✅ Get single geographic adjuster by ID
    getGeographicAdjusterById: builder.query({
      query: (id) => `admin/geographic-adjuster/${id}`,
      transformResponse: (res) => res?.body,
      providesTags: ["GeographicAdjuster"],
    }),

    // ✅ Add new geographic adjuster
    addNewGeographicAdjuster: builder.mutation({
      query: (newAdjuster) => ({
        url: `admin/geographic-adjuster`,
        method: "POST",
        body: newAdjuster,
      }),
      invalidatesTags: ["GeographicAdjuster"],
    }),

    // ✅ Update geographic adjuster
    updateGeographicAdjuster: builder.mutation({
      query: ({id , data}) => ({
        url: `admin/geographic-adjuster/${id}`,
        method: "PUT",
        body: data,
      }),
      invalidatesTags: ["GeographicAdjuster"],
    }),

    // ✅ Delete geographic adjuster
    deleteGeographicAdjuster: builder.mutation({
      query: (id) => ({
        url: `admin/geographic-adjuster/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["GeographicAdjuster"],
    }),

    uploadBulkGeographicAdjusters: builder.mutation({
      query: (payload) => {
        if (!payload || typeof payload !== 'object') {
          throw new Error("Payload must be a valid object");
        }
        return {
          url: `admin/geographic-adjuster/bulk`,
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: payload,
        };
      },
      invalidatesTags: ["GeographicAdjuster"],
    })
  }),
});

export const {
  useGetAllGeographicAdjustersQuery,
  useGetGeographicAdjusterByIdQuery,
  useAddNewGeographicAdjusterMutation,
  useUpdateGeographicAdjusterMutation,
  useDeleteGeographicAdjusterMutation,
  useUploadBulkGeographicAdjustersMutation  
} = geographicAdjusterApi;
